export default __webpack_public_path__ + "static/background-123496c279ded8fa6ef488a7694d1614.svg";